import { appReducer } from '.';
import { APP_REDUCER_NAME } from './constants';

type ReducerState = ReturnType<typeof appReducer>;

type State = {
  [APP_REDUCER_NAME]: ReducerState;
};

export const selectMenuActive = (state: State) =>
  state[APP_REDUCER_NAME].menuActive;

export const selectCityPopupActive = (state: State) =>
  state[APP_REDUCER_NAME].cityPopupActive;

export const selectCityDrawerActive = (state: State) =>
  state[APP_REDUCER_NAME].selectCityDrawerActive;

export const selectCity = (state: State) => state[APP_REDUCER_NAME].city;

export const selectMenuSearchActive = (state: State) =>
  state[APP_REDUCER_NAME].menuSearchActive;

export const selectSearchActive = (state: State) =>
  state[APP_REDUCER_NAME].searchActive;

export const selectAuthDrawerActive = (state: State) =>
  state[APP_REDUCER_NAME].authDrawerActive;

export const selectFavouriteProducts = (state: State) =>
  state[APP_REDUCER_NAME].favouriteProducts;

export const selectCartData = (state: State) =>
  state[APP_REDUCER_NAME].cartData;

export const selectCartDrawerActive = (state: State) =>
  state[APP_REDUCER_NAME].cartDrawerActive;

export const selectAvailableLocations = (state: State) =>
  state[APP_REDUCER_NAME].availableLocations;

export const selectCategoryTree = (state: State) =>
  state[APP_REDUCER_NAME].categoryTree;

export const selectTempCartItems = (state: State) =>
  state[APP_REDUCER_NAME].tempCartItems;

export const selectOrderUserCorrect = (state: State) =>
  state[APP_REDUCER_NAME].orderUserCorrect;

export const selectOrderDeliveryCorrect = (state: State) =>
  state[APP_REDUCER_NAME].orderDeliveryCorrect;

export const selectOrderCompanyInvoiceCorrect = (state: State) =>
  state[APP_REDUCER_NAME].orderCompanyInvoiceCorrect;

export const selectCatalogActive = (state: State) =>
  state[APP_REDUCER_NAME].catalogActive;

export const selectPartnersDrawerActive = (state: State) =>
  state[APP_REDUCER_NAME].partnersDrawerActive;

export const selectDeletedCartItems = (state: State) =>
  state[APP_REDUCER_NAME].deletedCartItems;

export const selectAlert = (state: State) => state[APP_REDUCER_NAME].alert;

export const selectHeaderButtonColor = (state: State) =>
  state[APP_REDUCER_NAME].headerButtonColor;

export const selectHelpDrawerActive = (state: State) =>
  state[APP_REDUCER_NAME].helpDrawerActive;

export const selectHelpDrawerScreen = (state: State) =>
  state[APP_REDUCER_NAME].helpDrawerScreen;
